import { getEncodedParams } from 'helpers/encodeParams';

export const allTacticsEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/tactics?start=${encodedParams.start}&end=${encodedParams.end}`;
};

export const singleTacticPlacementsEndpoint = (state, params) => {
    const { start, end } = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/tactic/${params.tactic}/placements?start=${start}&end=${end}`;
};



// WEBPACK FOOTER //
// ./src/services/tactics/selectors.js